import { render, staticRenderFns } from "./SpecialCourse.vue?vue&type=template&id=2ab5104a&scoped=true&"
import script from "./SpecialCourse.vue?vue&type=script&lang=js&"
export * from "./SpecialCourse.vue?vue&type=script&lang=js&"
import style0 from "./SpecialCourse.vue?vue&type=style&index=0&id=2ab5104a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab5104a",
  null
  
)

export default component.exports